import React, { useState, useEffect } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

import { Button } from "primereact/button";
import NouvelleFichesStock from "./nouvellesFichesStock";
import EnCours from "./enCours";
import Suivis from "./suivis.jsx";
import Valide from "./valide.jsx";
import Abandonnee from "./abandonnee.jsx";
import Toutes from "./toutes.jsx";
import Stockage from "./ficheStockage.jsx";
import HistoriqueMailsStock from "./historiqueMailsStock"; 
import "../../styles/custom-tabview.css";
import axios from "axios";
import HeaderStock from "./headerStock.jsx";

import { Dialog } from "primereact/dialog";

const apiUrl = process.env.REACT_APP_API_URL;

 const TABS = [
  { label: "Nouvelles", key: "nouvelles" },
  // { label: "En cours", key: "en_cours" },
  { label: "Suivis",   key: "devis" },
  { label: "Validé",  key: "valide" },
  { label: "Stockage",  key: "stockage" },
  { label: "Abandonnées",  key: "abandonnees" },
  { label: "Toutes",      key: "toutes" },
];

export default function FicheListe() {
  const [activeIndex, setActiveIndex] = useState(() => {
  const storedIndex = localStorage.getItem("activeTabIndexFiche");
  return storedIndex !== null ? parseInt(storedIndex, 10) : 0;
});

  const [showHistorique, setShowHistorique] = useState(false);


  const [counters, setCounters] = useState({
     nouvelles: 0,
    //  en_cours: 0,
     visites_planifiees: 0,
     devis: 0,
     suivis: 0,
     valide: 0,
     stockage:0,
     abandonnees:0,
     toutes: 0,
   });

  const tabPanels = [
    "Nouvelles",
    // "En cours",
    "Suivis",
    "Validé",
    "Stockage",
    "Abandonnées",
    "Toutes",
  ];



 const [globalSearch, setGlobalSearch] = useState("");


const [displayRejectedPopup, setDisplayRejectedPopup] = useState(false);
const [rejectedDevisList, setRejectedDevisList] = useState([]);
const [dismissedRejected, setDismissedRejected] = useState(false);


 useEffect(() => {
    axios.get(`${apiUrl}/IHM/api/fiche.php?pannel=true`)
      .then(res => setCounters(res.data))
      .catch(err => console.error("Erreur compteurs:", err));
  }, [activeIndex]);


 

  useEffect(() => {
    if (showHistorique && activeIndex < tabPanels.length) {
      setShowHistorique(false);
    }
  }, [activeIndex, showHistorique]);

  const handleTabChange = (index) => {
  setActiveIndex(index);
  localStorage.setItem("activeTabIndexFiche", index);
};
  const handleHistoriqueClick = () => {
    setShowHistorique(true);
    setActiveIndex(tabPanels.length);
  };


  useEffect(() => {
    if (!dismissedRejected) {
      axios
        .get(`${apiUrl}/IHM/api/checkEnvoi/check_rejected_devis_stock.php`)
        .then((response) => {
          if (response.data && response.data.length > 0) {
            setRejectedDevisList(response.data);
            setDisplayRejectedPopup(true);
          } else {
            setDisplayRejectedPopup(false);
          }
        })
        .catch((error) => {
          console.error("Erreur lors de la vérification des devis rejetés:", error);
        });
    }
  }, [dismissedRejected, activeIndex]);

  return (
    <div>
      <HeaderStock
        rejectedDevisList={rejectedDevisList}
        displayRejectedPopup={displayRejectedPopup}
        dismissedRejected={dismissedRejected}
        setDisplayRejectedPopup={setDisplayRejectedPopup}
      />

      <Dialog
        blockScroll
        header="Des devis n'ont pas été reçus !"
        onHide={() => {
          // Ne rien faire - empêcher la fermeture
          return;
        }}
        visible={displayRejectedPopup}
        style={{ width: "50vw", backgroundColor: "#fff" }}
        headerStyle={{
          backgroundColor: "#dc2626",
          color: "white",
          borderBottom: "none",
        }}
        closable={false}
        footer={
          <Button
            label="J'ai compris, je vais les renvoyer"
            icon="pi pi-check"
            severity="danger"
            onClick={() => {
              setDisplayRejectedPopup(false);
            }}
            autoFocus
          />
        }
      >
        <p>
          Les devis suivants n'ont pas été reçus.
          <br />
          Cela signifie que l'email n'a pas pu être délivré.
        </p>
        <ul>
          {rejectedDevisList.map((item) => (
            <li
              key={item.id}
              style={{
                marginBottom: "8px",
                borderBottom: "1px solid #eee",
                padding: "8px 0",
              }}
            >
              <b>{item.numero_devis}</b>
              <br />
              <span>
                Client : <b>{item.nom || "Non renseigné"}</b>
              </span>
              <br />
              <span>Email : {item.email}</span>
              <br />
              <span>Téléphone : {item.telephone || "Non renseigné"}</span>
              <br />
              <small style={{ color: "#666" }}>
                Envoyé le {new Date(item.date_envoi).toLocaleString("fr-FR")}
              </small>
            </li>
          ))}
        </ul>
        <p style={{ color: "#dc2626", fontSize: "14px", marginTop: "10px" }}>
          Un nouveau devis doit être envoyé à ces clients.
        </p>
      </Dialog>

      <div
        style={{
          overflowX: "auto",
          overflowY: "visible",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div className="flex flex-column md:flex-row justify-content-between md:align-items-center p-2 gap-3">
          <div
            style={{
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
              scrollbarWidth: "none",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                gap: "4px",
                minWidth: "max-content",
              }}
            >
              {TABS.map((tab, i) => {
                const isActive = i === activeIndex;
                return (
                  <div
                    key={i}
                    onClick={() => handleTabChange(i)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0 12px",
                      height: "35px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      flexShrink: 0,
                      backgroundColor: isActive ? "#0971b7" : "transparent",
                      touchAction: "manipulation",
                      WebkitTapHighlightColor: "transparent",
                      userSelect: "none",
                    }}
                  >
                    <span
                      style={{
                        color: isActive ? "#fff" : "#6b6b6b",
                        fontWeight: isActive ? 700 : 500,
                        fontSize: "13px",
                      }}
                    >
                      {tab.label}
                    </span>

                    <span
                      style={{
                        marginLeft: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        fontWeight: "bold",
                        fontSize: "10px",
                        width: "18px",
                        height: "18px",
                        backgroundColor: isActive ? "#F8F9FA" : "transparent",
                        color: isActive ? "#0A2540" : "#9a9a98",
                      }}
                    >
                      {counters[tab.key] ?? 0}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Search */}
          <div className="w-full md:w-auto">
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search" />
              <InputText
                value={globalSearch}
                onChange={(e) => setGlobalSearch(e.target.value)}
                placeholder="Rechercher un client..."
                className="w-full md:w-20rem"
              />
            </IconField>
          </div>
        </div>
      </div>

      {/* <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
        <TabPanel header="Nouvelles"><NouvelleFichesStock /></TabPanel>
        <TabPanel header="En cours"><EnCours /></TabPanel>
        <TabPanel header="Suivis"><Suivis /></TabPanel>
        <TabPanel header="Validé"><Valide /></TabPanel>
        <TabPanel header="Stockage"><Stockage /></TabPanel>
        <TabPanel header="Abandonnées"><Abandonnee /></TabPanel>
        <TabPanel header="Toutes"><Toutes /></TabPanel>

        {showHistorique && (
          <TabPanel header="Historique des mails de stockage">
           <HistoriqueMailsStock />
          </TabPanel>
        )}
      </TabView> */}

      <div style={{ padding: "1rem 0 0 0" }}>
        {activeIndex === 0 && <NouvelleFichesStock searchTerm={globalSearch} />}
        {/* {activeIndex === 1 && <EnCours searchTerm={globalSearch} />} */}
        {activeIndex === 1 && <Suivis searchTerm={globalSearch} />}
        {activeIndex === 2 && <Valide searchTerm={globalSearch} />}
        {activeIndex === 3 && <Stockage searchTerm={globalSearch} />}
        {activeIndex === 4 && <Abandonnee searchTerm={globalSearch} />}
        {activeIndex === 5 && <Toutes searchTerm={globalSearch} />}
      </div>
    </div>
  );
}
